import { render, staticRenderFns } from "./CDepartment.vue?vue&type=template&id=d7fbfaf2&"
import script from "./CDepartment.vue?vue&type=script&lang=ts&"
export * from "./CDepartment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports